import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=974a5c10&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"
import style0 from "./LandingPageView.vue?vue&type=style&index=0&id=974a5c10&prod&scoped=true&lang=scss"
import style1 from "./LandingPageView.vue?vue&type=style&index=1&id=974a5c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a5c10",
  null
  
)

export default component.exports